import "./QuoteBlock.scss";
import { QuoteBlockProps } from "/Models/Generated/QuoteBlockProps";
import {
  CircularWrapper,
  OptimizelyEditProperty,
  Picture,
} from "/App.Components";
import cn from "classnames";

const QuoteBlock = ({
  quote,
  quotePropertyName,
  quoteBy,
  quoteByPropertyName,
  titleOrCompany,
  titleOrCompanyPropertyName,
  image,
  imagePropertyName,
  hideLine,
}: QuoteBlockProps) => (
  <div className="quote-block-norad">
    <div className="quote-block-norad__image-and-quote">
      {(image || imagePropertyName) && (
        <div className="quote-block-norad__image-container quote-block-norad__image-container--desktop">
          <OptimizelyEditProperty propertyName={imagePropertyName} clientRender>
            <div className="quote-block-norad__image-container quote-block-norad__image-container--desktop">
              <CircularWrapper size="Small">
                <Picture {...image} pictureBehaviour="Cover" />
              </CircularWrapper>
            </div>
          </OptimizelyEditProperty>
        </div>
      )}

      {(quote || quotePropertyName) && (
        <div>
          <blockquote>
            {!hideLine && <span className="quote-block-norad__line"></span>}
            <span
              className={cn({ "epi-editContainer": quotePropertyName })}
              data-epi-property-name={quotePropertyName}
            >
              {quote}
            </span>
          </blockquote>
          {(quoteBy || quoteByPropertyName) && (
            <div className="quote-block-norad__quote-by-container--desktop">
              <div className="quote-block-norad__quote-by">
                <OptimizelyEditProperty propertyName={quoteByPropertyName}>
                  {quoteBy}
                </OptimizelyEditProperty>
              </div>
              <OptimizelyEditProperty propertyName={titleOrCompanyPropertyName}>
                {titleOrCompany && (
                  <div className="quote-block-norad__title">
                    {titleOrCompany}
                  </div>
                )}
              </OptimizelyEditProperty>
            </div>
          )}
        </div>
      )}
    </div>
    <div className="quote-block-norad__image-and-quote-by-container">
      {image && (
        <div className="quote-block-norad__image-container quote-block-norad__image-container--mobile">
          <CircularWrapper size="Small">
            <Picture {...image} pictureBehaviour="Cover" />
          </CircularWrapper>
        </div>
      )}
      {quoteBy && (
        <div className="quote-block-norad__quote-by-container--mobile">
          <div className="quote-block-norad__quote-by">{quoteBy}</div>
          {titleOrCompany && (
            <div className="quote-block-norad__title">{titleOrCompany}</div>
          )}
        </div>
      )}
    </div>
  </div>
);

export default QuoteBlock;
